import { render, staticRenderFns } from "./ScrollToOffsetYIcon.vue?vue&type=template&id=2eb54cad&"
import script from "./ScrollToOffsetYIcon.vue?vue&type=script&lang=js&"
export * from "./ScrollToOffsetYIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports